export const useBodyScroll = () => {
  const allowBodyScroll = () => {
    document.body.style.overflow = 'auto'
  }

  const disableBodyScroll = () => {
    document.body.style.overflow = 'hidden'
  }

  return {
    allowBodyScroll,
    disableBodyScroll,
  }
}
